(function () {
  var T = Number(window.sgFreeShip || 0);
  if (!T) return;
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function totalCents(inner) {
    var el = inner.querySelector('.totals__total-value');
    if (!el) return null;
    var n = parseFloat(el.textContent.replace(/[^0-9.]/g, ''));
    return isNaN(n) ? null : Math.round(n * 100);
  }
  function render() {
    var inner = document.querySelector('cart-drawer .drawer__inner');
    if (!inner) return;
    var old = inner.querySelector('.sg-ship');
    var total = totalCents(inner);
    if (inner.classList.contains('is-empty') || total === null) { if (old) old.remove(); return; }
    if (old && old.getAttribute('data-total') === String(total)) return;
    var left = T - total;
    var pct = Math.max(0, Math.min(100, Math.round((total / T) * 100)));
    var box = old || document.createElement('div');
    box.className = 'sg-ship';
    box.setAttribute('data-total', String(total));
    box.setAttribute('role', 'status');
    box.style.cssText = 'margin:0 0 16px;font-size:14px;line-height:1.4';
    box.innerHTML = (left > 0
      ? '<p style="margin:0 0 8px">You&rsquo;re <strong>' + money(left) + '</strong> away from free US shipping.</p>'
      : '<p style="margin:0 0 8px"><strong>Free US shipping unlocked.</strong></p>') +
      '<div style="height:6px;border-radius:3px;background:rgba(255,255,255,.14);overflow:hidden"><span style="display:block;height:100%;width:' + pct + '%;background:' + (left > 0 ? '#E0281E' : '#30D158') + '"></span></div>';
    if (!old) {
      var head = inner.querySelector('.drawer__header');
      if (head && head.parentNode) head.parentNode.insertBefore(box, head.nextSibling); else inner.insertBefore(box, inner.firstChild);
    }
  }
  var timer;
  function init() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    render();
    new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(render, 50); }).observe(drawer, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
